// Settings the practice dock remembers in this browser. Private browsing or a
// full storage just means they aren't remembered.

export function loadStored(key) {
    try {
        return JSON.parse(window.localStorage.getItem(key)) || null;
    } catch (e) {
        return null;
    }
}

export function saveStored(key, value) {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        // Not remembered.
    }
}
